var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45833 2.5C4.27208 2.5 2.5 4.27208 2.5 6.45833V13.6914C2.5 14.2485 2.77844 14.769 3.24219 15.0781L3.75 15.4167V6.45833C3.75 4.9625 4.9625 3.75 6.45833 3.75H15.4167L15.0781 3.24219C14.7694 2.77844 14.2489 2.5 13.6914 2.5H6.45833ZM6.875 4.58333C5.61676 4.58333 4.58333 5.61676 4.58333 6.875V15.2083C4.58333 16.4666 5.61676 17.5 6.875 17.5H15.2083C16.4666 17.5 17.5 16.4666 17.5 15.2083V6.875C17.5 5.61676 16.4666 4.58333 15.2083 4.58333H6.875ZM6.875 5.83333H15.2083C15.7909 5.83333 16.25 6.29241 16.25 6.875V15.2083C16.25 15.7909 15.7909 16.25 15.2083 16.25H6.875C6.29241 16.25 5.83333 15.7909 5.83333 15.2083V6.875C5.83333 6.29241 6.29241 5.83333 6.875 5.83333Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b9148e92c3dbfe9eb82c8e0c1b886dbd.svg";
export { ForwardRef as ReactComponent };